import { useQuery } from "@tanstack/react-query";
import { tarefaService } from "@/services/api/tarefa.service";
import { TarefaResumoAdminDTO } from "@/types/tarefa.type";

export function useTarefaAdminKpis() {
  const { data, isLoading, error, refetch } = useQuery<TarefaResumoAdminDTO>({
    queryKey: ["tarefa-resumo-admin"],
    queryFn: () => tarefaService.getResumoAdminTarefas(),
  });

  const resumo: TarefaResumoAdminDTO = data || {
    totalGeral: 0,
    totalAbertas: 0,
    totalPendentes: 0,
    totalEmExecucao: 0,
  };

  return {
    resumo,
    loading: isLoading,
    error: error instanceof Error ? error : null,
    fetchTotais: async () => {
      await refetch();
    },
  };
}
